import { FC, useState } from 'react'
import { useDispatch } from 'react-redux'
import { Margin } from '../hoc/Margin'
import { Popup } from '../hoc/Popup'
import { action_setLoading } from '../store/actions/popup'
import { IUser } from '../types/user'
import { MetamaskMethods } from '../utils/wallet/metamask/provider'
import { fromStringToWei } from '../utils/wallet/utils'
import { Button } from './UI/Buttons'
import { floatFilter, InputWithState } from './UI/Input'

interface DonationProps {
    showState: [boolean, (state: boolean) => void]
    user: IUser
}
export const Donation: FC<DonationProps> = ({ showState, user }) => {
    const [amount, setAmount] = useState('0')
    const dispatch = useDispatch()

    async function pay() {
        dispatch(action_setLoading(true))
        try {
            const { donate } = await MetamaskMethods()
            await donate(user.metamaskAddress, fromStringToWei(amount))
            const [, setShow] = showState
            setShow(false)
        } catch (e) {
            console.error(e)
        }
        dispatch(action_setLoading(false))
    }
    return (
        <Popup showState={showState} title="Support the author">
            <InputWithState
                helper="CAL"
                state={[amount, setAmount]}
                filter={floatFilter}
                title="Amount"
            ></InputWithState>
            <Margin margin={{ top: 10 }}>
                <Button type="submit" fill onClick={pay}>
                    Donate
                </Button>
            </Margin>
        </Popup>
    )
}
